import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Space extends React.PureComponent {
    static propTypes = {
        content: PropTypes.number,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return <div style={{ height: `${content}px` }} />;
    }
}

export default errorBoundary(Space);
